export default __webpack_public_path__ + "static/media/circle-two.2bc3b988.svg";